export default __webpack_public_path__ + "static/media/ourstory-team-2.df542b53.jpg";